import { Injectable, effect, inject } from "@angular/core";
import * as Sentry from "@sentry/angular";
import { SpanAttributeValue } from "@sentry/core";
import { applicationStringFromApplicationType, productStringFromApplicationType } from "src/app/views-interfaces/ApplicationType.enum";
import { AuthService } from "../auth/auth.service";
import { DashboardsService } from "../dashboards-service/dashboards.service";
import { FirmsService } from "../firms-service/firms.service";
import { CryptoService } from "../crypto-service/crypto.service";
import { IframeMessagesService } from "../iframe-messages-service";

@Injectable({
    providedIn: "root",
})
export class SentryService {
    private authService = inject(AuthService);
    private iframeMessagesService = inject(IframeMessagesService);
    private firmsService = inject(FirmsService);
    private dashboardsService = inject(DashboardsService);

    constructor() {
        effect(async () => {
            const currentUser = this.authService.currentUser();
            const currentDashboard = this.dashboardsService.currentDashboard();
            if (currentUser && currentDashboard) {
                Sentry.getCurrentScope().setUser({
                    id: currentUser.sub,
                    email: CryptoService.bytesArrToHex(await CryptoService.sha256(currentUser.email)),
                    firm_id: currentUser.firm_id,
                    dashboard_id: currentDashboard?.Id,
                });
            }
        });
    }

    trace(name: string, op: string, f: () => Promise<{ key: string; value: SpanAttributeValue | undefined }[]>) {
        Sentry.startSpanManual({ name, op }, async (span) => {
            const additionalInfo = await f();
            const currentDashboard = await this.dashboardsService.getCurrentDashboard();
            const firm = await this.firmsService.getFirm();
            span?.setAttribute("Site URL", this.iframeMessagesService.messagesOrigin());
            span?.setAttribute("Application", applicationStringFromApplicationType(currentDashboard.ApplicationType));
            span?.setAttribute("Product", productStringFromApplicationType(currentDashboard.ApplicationType));
            span?.setAttribute("Firm name", firm?.Name);
            span?.setAttribute("Dashboad title", currentDashboard?.Title);
            span?.setAttribute("Tax year", currentDashboard.TaxYear);
            for (const item of additionalInfo) {
                span?.setAttribute(item.key, item.value);
            }
            span?.end();
        });
    }
}
